import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getDocument, getDocumentApmc } from "../../../auth/services/privateapicalling";
import { formFieldDataP1,formFieldDataP2,formFieldDataP3 } from "../../../../core/data/json/DistrictAPMC";

const SingleView: React.FC<{ docId: string | null,type?:string }> = ({ docId ,type}) => {
  const [file, setFile] = useState<{ fileData: string; mimeType: string; fileName: string } | null>(null);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state: any) => state.auth.token);
const language = useSelector((state:any)=>state.auth.language);

function buildResponseMap(...jsonDataArrays) {
  return jsonDataArrays
    .flat() // Combine all arrays
    .filter(field => field && field.response) // Safety check
    .flatMap(field => field.response)
    .filter(resp => resp && resp.responseVal) // Safety check
    .reduce((acc, resp) => {
      acc[resp.responseVal] = resp.responseName;
      return acc;
    }, {});
}

// Usage
// const responseMap = buildResponseMap(datafield1, datafield2, datafield3);

// Build map once
const baseResponseMap = buildResponseMap(formFieldDataP1, formFieldDataP2, formFieldDataP3);

// Add explicit mappings for site inspection photos (these override or add to existing values)
const responseMap = {
  ...baseResponseMap,
  siteInspectionPhoto1: "Site Inspection Photo 1",
  siteInspectionPhoto2: "Site Inspection Photo 2",
  siteInspectionPhoto3: "Site Inspection Photo 3",
  siteInspectionPhoto4: "Site Inspection Photo 4",
};

  useEffect(() => {
  const loadFile = async () => {
    if (!docId) return;
       setFile(null)
    setLoading(true);
    try {
      const response = await getDocumentApmc(docId, token,type);
     

      if (response.success && response.attachments) {
        // Assuming you're interested in the first attachment
        const [key] = Object.keys(response.attachments);
        const attachment = response.attachments[key];

        setFile({
          fileData: attachment.base64,
          mimeType: attachment.contentType,
          fileName: key, // use the attachment key as filename if needed
        });
      } else {
        setFile(null);
      }
    } catch (error) {
      
      setFile(null);
    }
    setLoading(false);
  };

  loadFile();
}, [docId]);


  return (
    <div className="modal fade" id="apmc_modal" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{language.vdoc}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body" style={{ maxHeight: "500px", overflowY: "auto" }}>
            {loading && <p>Loading...</p>}
            {!loading && !file && <p>No document found</p>}
            {file && (
              <div className="mt-3">
                <p><strong>{responseMap[file.fileName] || responseMap[file.fileName.replace(/\.[^/.]+$/, '')] || file.fileName}</strong></p>
                {file.mimeType.startsWith("image/") && (
                  <img src={file.fileData} alt={file.fileName} style={{ width: "100%", maxHeight: "700px" }} />
                )}
                {file.mimeType === "application/pdf" && (
                  <iframe src={file.fileData} width="100%" height="500px" title="PDF Viewer" />
                )}
                {!file.mimeType.startsWith("image/") && file.mimeType !== "application/pdf" && (
                  <a href={file.fileData} download={file.fileName} className="text-primary">
                    {language.down} {file.fileName}
                  </a>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer d-flex justify-content-between">
            {file && (
              <a href={file.fileData} download={file.fileName} className="btn btn-success">
                {language.down}
              </a>
            )}
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              {language.close}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleView;
